/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import CardsTab from './CardsTab';
import EditBoardViewTabs from './EditBoardViewTabs';
import { useHasBoardSettingsTab } from '../hooks/useHasBoardSettingsTab';
//@ts-expect-error untyped
import * as Alerts from 'customer-data-ui-utilities/alerts/Alerts';
import isNumber from 'transmute/isNumber';
import { useCallback, useState } from 'react';
import { BoardPanelPresentationProvider } from '../context/BoardPanelPresentationContext';
import { useEditBoardSettingsPanelContext } from '../context/EditBoardSettingsPanelContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EditBoardSettingsPanel = ({
  defaultTabId,
  onClose,
  hasTags,
  onSaveComplete,
  forceCardsTab
}) => {
  const {
    objectTypeId,
    currencyOptions,
    saveDraft,
    updateDraft,
    resetDraft,
    settings
  } = useEditBoardSettingsPanelContext();
  const hasBoardSettingsTab = useHasBoardSettingsTab(objectTypeId) && currencyOptions;
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const handleReset = useCallback(() => {
    setHasUnsavedChanges(false);
    resetDraft();
  }, [setHasUnsavedChanges, resetDraft]);
  const handleUpdateDraft = useCallback(draft => {
    setHasUnsavedChanges(true);
    updateDraft(draft);
  }, [setHasUnsavedChanges, updateDraft]);
  const handleSave = useCallback(() => {
    if (settings === null) {
      return Promise.resolve();
    }
    onClose();
    return saveDraft(settings).then(() => {
      onSaveComplete(settings);
      Alerts.addSuccess('editCardsPanel.alertSuccess', {}, {
        'data-test-id': 'card-preference-update-success-alert'
      });
    }, () => {
      Alerts.addError('editCardsPanel.alertFailure', {}, {
        'data-test-id': 'card-preference-update-error-alert'
      });
    }).finally(() => {
      resetDraft();
    });
  }, [onClose, resetDraft, settings, saveDraft, onSaveComplete]);
  if (settings === null) {
    return null;
  }
  const inactiveCardInput = settings.inactiveCardPreferences.value;
  const hasInvalidInput = !isNumber(inactiveCardInput) || inactiveCardInput < 1;
  return /*#__PURE__*/_jsx(BoardPanelPresentationProvider, {
    hasTags: hasTags,
    settings: settings,
    updateDraft: handleUpdateDraft,
    currencyOptions: currencyOptions,
    objectTypeId: objectTypeId,
    forceCardsTab: forceCardsTab,
    children: /*#__PURE__*/_jsxs(Panel, {
      "data-selenium-test": "edit-cards-panel",
      width: "600px",
      children: [/*#__PURE__*/_jsxs(PanelHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          "data-test-id": "header-close-button",
          onClick: () => {
            onClose();
            handleReset();
          }
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "editCardsPanel.header"
          })
        })]
      }), /*#__PURE__*/_jsx(PanelBody, {
        paddingInline: "1000",
        children: hasBoardSettingsTab ? /*#__PURE__*/_jsx(EditBoardViewTabs, {
          defaultTabId: defaultTabId
        }) : /*#__PURE__*/_jsx(CardsTab, {})
      }), /*#__PURE__*/_jsxs(PanelFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          "data-test-id": "footer-save-button",
          use: "primary",
          disabled: !hasUnsavedChanges || hasInvalidInput,
          onClick: handleSave,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "editCardsPanel.footer.saveButton"
          })
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "footer-close-button",
          use: "secondary",
          onClick: () => {
            handleReset();
            onClose();
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "editCardsPanel.footer.cancelButton"
          })
        })]
      })]
    })
  });
};